"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, removeAttribute, setAttribute, findIn, findAllIn} from "@elements/dom-utils";

export function init () {
    onFind('.js-download-list', function (list) {
        let submitButton = findIn('.js-download-list__submit', list);

        setButtonState(list, submitButton);

        on('change', () => {
            setButtonState(list, submitButton);
        }, list);
    });
}

function setButtonState(list, submitButton) {
    if (findAllIn('.js-download-list__input:checked', list).length) {
        removeAttribute('disabled', submitButton)
    } else {
        setAttribute('disabled', true, submitButton)
    }
}